module.exports = __webpack_public_path__ + "img/reference-autohotspot.9043c7da.webp";